import { useEffect } from 'react';

export const useLogEffect = (
  title: string,
  value: any,
  deps = [value],
  level: 'log' | 'warn' | 'error' | 'debug' = 'log',
) =>
  useEffect(() => {
    try {
      console[level](title, value);
    } catch (_err) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

export const useConditionalLogEffect = (
  title: string,
  condition: boolean,
  value: any,
  level: 'log' | 'warn' | 'error' | 'debug' = 'log',
) => {
  useEffect(() => {
    if (!condition) {
      return;
    }

    try {
      console[level](title, value);
    } catch (err) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, condition, level]);
};
